import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import {environment} from '@environments/environment';
import {COMMIT_HASH, COMMIT_MESSAGE} from '@environments/commit';
import { provideMatomo, withRouter } from 'ngx-matomo-client';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { appRoutes } from '@app/app.routes';

// Aura ships an emerald/green `primary` palette, which leaks its green into
// unstyled components (p-steps, etc.). Remap `primary` to the app's brand blue
// so blue is the framework default and per-component overrides are unnecessary.
// Anchored on the SCSS brand tokens so Aura's semantic slots line up:
//   500 = $primaryLight (#007BDD, light-mode accent / --color-link)
//   400 = $primaryLighter (#2196F3, dark-mode accent)
//   600 = $primary (#005293, light hover), 700 = $primaryDark (#004277, active)
// Aura also defaults form fields to border-radius 6px (border.radius.md); the
// app uses 4px corners everywhere, so override the form-field radius globally.
const TurboAura = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#e7f3fd',
            100: '#c3e0fb',
            200: '#90c7f8',
            300: '#4fa8f5',
            400: '#2196f3',
            500: '#007bdd',
            600: '#005293',
            700: '#004277',
            800: '#003561',
            900: '#002b4f',
            950: '#001d35',
        },
        formField: {
            borderRadius: '{border.radius.sm}',
        },
    },
});
import { appProviders } from '@app/app.providers';
import { AppComponent } from './app/app.component';


if (environment.production) {
  enableProdMode();
}

if (environment.type === 'staging') {
  console.log('last commit:', COMMIT_HASH, '-', COMMIT_MESSAGE);
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(appRoutes),
        provideAnimations(),
        providePrimeNG({
            ripple: true,
            theme: {
                preset: TurboAura,
                options: {
                    darkModeSelector: '.dark',
                    cssLayer: {
                        name: 'primeng',
                        order: 'primeng',
                    },
                },
            },
        }),
        provideMatomo({
            trackerUrl: 'https://tracking.emailchef.com',
            siteId: environment.matomoSiteId
        }, withRouter()),
        provideHttpClient(withInterceptorsFromDi()),
        ...appProviders,
    ]
})
  .catch(err => console.error(err));
